import { Button, Divider, Paper, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import useStyles from "./styles";

function BannerItem({ item }) {
  const classes = useStyles();
  return (
    <Paper className={classes.bannerItem}>
      <img src={item.bannerImg} alt="Banner" className={classes.bannerImage} />
      <div
        className={`${classes.mainOverlay} ${classes.backgroundOverlay}`}
      ></div>
      <div
        className={`${classes.flex} ${classes.mainOverlay} ${classes.bannerOverlay}`}
      >
        <div className={`${classes.flex} ${classes.iconContainer}`}>
          <img
            src={item.bannerIcon}
            alt="Best Selling Icon"
            height={55}
            width={55}
          />
        </div>
        <div className={`${classes.flex} ${classes.bannerContent}`}>
          <Typography variant="h4" className={classes.bannerTitle}>
            {item.bannerTitle}
          </Typography>
          <Typography variant="subtitle1" className={classes.bannerSubtitle}>
            {item.bannerSubtitle}
          </Typography>
        </div>
        <Divider
          className={`${classes.backgroundColorPrimary} ${classes.divider}`}
        />
        <Link to={item.bannerLink} style={{ textDecoration: "none" }}>
          <Button className={classes.button}>
            <Typography variant="subtitle1">{item.buttonText}</Typography>
          </Button>
        </Link>
      </div>
    </Paper>
  );
}

export default BannerItem;
